"use strict";


//const baseURL = "ENV['BACKEND_API_URL'] || ENV['BASE_URL']";

// commented by harris
// const baseURL = "http://localhost:3000/admin/login";
//const baseURL = "http://localhost:8080/admin/login";
// sandbox
//const baseURL = "https://cis-sandbox-backend-app.politepond-89738b33.southeastasia.azurecontainerapps.io";

//production
const baseURL = "https://cis-prod-backend-app.bluepond-a3422fa8.southeastasia.azurecontainerapps.io";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.baseURL = baseURL; 
